import styles from './ArticleDate.module.scss';
import classNames from 'classnames';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';

export interface UI_ArticleDateProps {
	date: string;
	dateStatus: string;
	className?: string;
}

export const UI_ArticleDate = ({ date, dateStatus, className }: UI_ArticleDateProps) => (
	<UI_Paragraph className={classNames(styles.ArticleDate, className)}>
		{dateStatus} {date}
	</UI_Paragraph>
);
